import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {FormattedMessage} from 'react-intl';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import ScenarioBox from '../scenarios/ScenarioBox.react';
import {injectIntl, defineMessages} from 'react-intl';
import {getLastOrganisationId} from '../app/LastOrganisationId';

const messages = defineMessages({
    title: {id: 'channelList.usedScenariosTitle', 'defaultMessage': 'Used scenarios'}
});

class UsedScenarioList extends React.Component {

    typeName = 'usedScenarios';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    static contextTypes = {
        router: PropTypes.object
    };

    render() {
        const data = this.props.user.organisation;
        return (
			<AppPanel title={this.props.intl.formatMessage(messages.title)}>
                <h3><FormattedMessage defaultMessage="Used scenarios:" id="channelList.usedScenarios" /></h3>

				{data.usedScenarios.edges.length > 0 ?
                    <div>

                        <div className="scenarioGridList">
                            {data.usedScenarios.edges.map(({node}, idx) => {
                                if (node.scenario) {
                                    return (
                                        <ScenarioBox key={idx} metadata={types['scenarios']} scenario={node.scenario}
                                                     urlMapping={urlMapping}/>
                                    );
                                }
                            })}
                        </div>
                    </div>
                : null}
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(UsedScenarioList), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    description,
					usedScenarios(first: 100) {
                        edges {
                            node {
                                id,
                                realId,
                                scenario, {
	                                id,
	                                realId,
	                                ${ScenarioBox.getFragment('scenario')}
								}
                            }
                        }
                    }
                }
            }
        `,
    },
});
